import { render, staticRenderFns } from "./AnswerFilterChips.vue?vue&type=template&id=b0dd3d62&scoped=true&"
import script from "./AnswerFilterChips.vue?vue&type=script&lang=js&"
export * from "./AnswerFilterChips.vue?vue&type=script&lang=js&"
import style0 from "./AnswerFilterChips.vue?vue&type=style&index=0&id=b0dd3d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd3d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
